import React from "react";
import "./Educations.css";
import DegreeCard from "../../components/degreeCard/DegreeCard.js";
import { degrees } from "../../portfolio";

function Educations(props) {
  const theme = props.theme;

  return (
    <div className="main" id="educations">
      <div className="educations-body-div">
        {degrees.degrees.map((degree, index) => {
          return <DegreeCard degree={degree} theme={theme} key={index} />;
        })}
      </div>
    </div>
  );
}

export default Educations;
